import clsx from 'clsx'
import styles from './styles.module.scss'

export const Marks = ({
  onChangeValue,
  minValue,
  maxValue,
  isRange,
  values,
}) => {
  const isActiveMark = (mark: number) => {
    if (values.length > 1) {
      return mark >= values[0] && mark <= values[1]
    }
    return mark <= values[0]
  }

  const handleClickMark = (mark: number) => {
    if (isRange) {
      if (mark < values[0]) {
        onChangeValue(0, mark)
      } else {
        onChangeValue(1, mark)
      }
    } else {
      onChangeValue(0, mark)
    }
  }

  const marks = maxValue / 5
  const marksArray = [
    minValue,
    marks,
    marks * 2,
    marks * 3,
    marks * 4,
    maxValue,
  ]

  return (
    <>
      {marksArray.map((mark, index) => (
        <div
          key={index}
          className={styles.pointerContainer}
          style={{ left: `${(mark / maxValue) * 100}%` }}
          onClick={() => handleClickMark(mark)}
        >
          <div className={styles.value}>{mark}</div>
          <div
            className={clsx(styles.pointer, {
              [styles.pointerActive]: isActiveMark(mark),
            })}
          />
        </div>
      ))}
    </>
  )
}
